import { CircularProgress } from "@mui/material"


interface IProps {
    size?: number,
    value: number,
}

export default function CustomCircualrProgress({ size = 40, value }: IProps) {
    return (
        <div style={{width: size, height: size}} className='center bg-action-active bg-opacity-55 p-0.5 rounded-full'>
            <CircularProgress size={size - 4} variant="determinate" value={value} />
        </div>
    )
}
